'use client';

import { useGlobalErrorLogger } from '@/app/hooks/useGlobalErrorLogger';
import { useScrollToTopOnRouteChange } from '@/app/hooks/useResetScrollToTop';
import { useGlobalScreenHeight } from '@/app/hooks/useScreenHeight';
import { useRUMRecording } from '@/components/hooks/rum';
import { useTDPageview } from '@/components/hooks/td';

export const ClientConfigs = () => {
  useRUMRecording();
  useTDPageview();
  useScrollToTopOnRouteChange();
  useGlobalErrorLogger();
  useGlobalScreenHeight();
  return null;
};
